









import Vue from "vue"

export default Vue.extend({
    computed: {
        typeCheckJSON: {
            get(): boolean {
                return this.$store.direct.state.user.typeCheckJSON
            },
            set() {
                this.$store.direct.dispatch.user.toggleTypeCheckJSON()
            }
        }
    }
})
